// Rời form tạo đơn khi đang nhập dở: biết cú bấm nào là rời trang, và khách vừa nhập có đáng hỏi lưu
// vào Khách quen không (hooks/useLeaveGuard.ts, components/orders/SaveCustomerOnLeaveDialog.tsx).

import { isValidVnPhone, normalizePhoneVN } from "./format"

type ClickLike = Pick<MouseEvent, "button" | "metaKey" | "ctrlKey" | "shiftKey" | "altKey" | "defaultPrevented"> & {
  target: EventTarget | null
}
type Here = Pick<Location, "href" | "origin" | "pathname" | "search">

/**
 * Đường dẫn trong app mà cú bấm này sắp mở (thanh tab, menu, "Quay lại"…). null: không rời trang —
 * bấm chuột giữa / Ctrl+bấm (mở tab mới), liên kết sang site khác, tải file, cùng trang.
 */
export function leaveTarget(e: ClickLike, here: Here): string | null {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null
  const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null | undefined
  if (!a || (a.target && a.target !== "_self") || a.hasAttribute("download")) return null
  const url = new URL(a.getAttribute("href") ?? "", here.href)
  if (url.origin !== here.origin) return null
  if (url.pathname === here.pathname && url.search === here.search) return null
  return url.pathname + url.search + url.hash
}

export interface CustomerDraft {
  name: string
  phone?: string | null
  street?: string | null
  ward?: string | null
  district?: string | null
  city?: string | null
  lat?: number | null
  lng?: number | null
  geoAddress?: string | null
}

/** Body POST /customers (createCustomerSchema) */
export interface CustomerToSave {
  name: string
  phone: string
  address?: {
    street: string
    ward: string
    district: string | null
    city: string
    lat: number | null
    lng: number | null
    geoAddress: string | null
  }
}

/**
 * Khách nhập ở form → body lưu vào danh bạ. Cần tên + SĐT di động hợp lệ (khách quen = có SĐT), không
 * thì null (không hỏi lưu). Địa chỉ kèm theo khi đủ số nhà, phường / xã, tỉnh — thiếu thì lưu khách không địa chỉ.
 */
export function customerToSave(d: CustomerDraft): CustomerToSave | null {
  const name = d.name.trim()
  const phone = normalizePhoneVN(d.phone)
  if (!name || !isValidVnPhone(phone)) return null
  const street = d.street?.trim() ?? ""
  const ward = d.ward?.trim() ?? ""
  const city = d.city?.trim() ?? ""
  if (street.length < 3 || !ward || !city) return { name, phone }
  const hasPin = d.lat != null && d.lng != null
  return {
    name,
    phone,
    address: {
      street,
      ward,
      district: d.district?.trim() || null,
      city,
      lat: hasPin ? d.lat! : null,
      lng: hasPin ? d.lng! : null,
      geoAddress: hasPin ? d.geoAddress || null : null,
    },
  }
}
